import React, { useState } from 'react';
import one from '../assets/gallery-north-zone-2025-01.jpeg';
import two from '../assets/gallery-para-athlete-02.jpeg';
import three from '../assets/gallery-senior-2025-02.jpeg';
import five from '../assets/gallery-para-athlete-01.jpeg';
import six from '../assets/gallery-north-zone-2025-02.jpeg';
import seven from '../assets/gallery-para-athlete-03.jpg';
import eight from '../assets/gallery-senior-2025-01.jpeg';
import nine from '../assets/gallery-north-zone-2025-03.jpeg';
import ten from '../assets/gallery-senior-2025-03.jpeg';
import eleven from '../assets/gallery-junior-2024-01.jpg';
import twelve from '../assets/gallery-junior-2024-02.jpg';
import thirteen from '../assets/gallery-junior-2024-03.jpg';
import JS2025One from '../assets/gallery-subjunior-2025-01.jpg';
import JS2025Two from '../assets/gallery-subjunior-2025-02.jpeg';
import JS2025Three from '../assets/gallery-subjunior-2025-03.jpeg';
import './Gallery.css';

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedGroupTitle, setSelectedGroupTitle] = useState("");

  const imageGroups = [
    {
      title: 'Sub-Junior U-13, 15, 17 State Championships 2025',
      images: [JS2025One, JS2025Two, JS2025Three],
    },
    {
      title: 'Senior & Mini (U-11) State Championships 2025',
      images: [eight, three, ten],
    },
    {
      title: 'Opening Ceremony North-Zone 2025',
      images: [eight, three, ten],
    },
    {
      title: 'Closing Ceremony North-Zone 2025',
      images: [one, six, nine],
    },
    {
      title: 'Para-Athlete Achievements',
      images: [five, two, seven],
    },
    {
      title: 'Junior State Badminton Championship 2024',
      images: [eleven, twelve, thirteen],
    },
  ];

  const handleImageClick = (imgUrl, groupTitle) => {
    setSelectedImage(imgUrl);
    setSelectedGroupTitle(groupTitle);
  };

  const handleCloseLightbox = () => {
    setSelectedImage(null);
    setSelectedGroupTitle("");
  };

  return (
    <div className="gallery-page-container container py-5">
      <h2 className="text-center mb-3 gallery-title text-gradient text-uppercase">Memorable Moments</h2>
      <p className="lead text-center text-muted mb-5">
        Explore photo collections from recent tournaments, training camps, and awards ceremonies. Click on any image to zoom.
      </p>

      {imageGroups.map((group, gIndex) => (
        <div key={gIndex} className="gallery-group">
          <h4 className="gallery-group-title">{group.title}</h4>
          <div className="gallery-grid">
            {group.images.map((img, iIndex) => (
              <div 
                className="gallery-item" 
                key={iIndex}
                onClick={() => handleImageClick(img, group.title)}
              >
                <img src={img} alt={`gallery-${gIndex}-${iIndex}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* React Lightbox Modal Popup */}
      {selectedImage && (
        <div 
          className="lightbox-modal" 
          onClick={handleCloseLightbox}
        >
          <div 
            className="lightbox-content" 
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the image
          >
            <button 
              className="lightbox-close-btn" 
              onClick={handleCloseLightbox}
              aria-label="Close image popup"
            >
              ×
            </button>
            <img 
              src={selectedImage} 
              alt="Zoomed gallery preview" 
              className="lightbox-img" 
            />
            <div className="lightbox-caption">
              {selectedGroupTitle}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
